import { CSSProperties, ReactNode } from "react";

type Props = {
  alignSelf?: CSSProperties["alignSelf"];
  position?: CSSProperties["position"];
  top?: CSSProperties["top"];
  style?: CSSProperties;
  children?: ReactNode;
};

export const Sticky = ({
  alignSelf = "flex-Start",
  position = "sticky",
  top = "1rem",
  children,
  ...style
}: Props) => {
  return <div style={{ alignSelf, position, top, ...style }}>{children}</div>;
};
